import ChapterListingComponent from "Pages/MyBatchTestSyllabus/ChapterListingComponent";
import { testSyllabusDetailIF } from "Pages/MyBatchTestSyllabus/MyBatchTestSyllabus";
import {
  HeaderTabDiv,
  StyledSpan2,
} from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchSyllabusTab";
import PlannedLectureViewCard from "Pages/MySchedule/TOCModal/PlannedLectureViewCard";
import { useEffect, useState } from "react";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { getAllNodes } from "utilFunctions/helperFunctions/utilFunctions";
const MainDiv = styled<any>("div")`
  display: flex;
  gap: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "16px"};
  margin: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "0px 12px 0px 34px"};
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "16px 0px 0px 0px"};
  height: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? "calc(100vh - 130px) !important"
      : "calc(100vh - 195px) !important"};
`;
const ScheduledDiv1 = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "30%" : "30%"};
  border-right: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "1px solid #AFAFAF" : ""};
  background: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "#fff" : "#fff"};
  border-radius: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "12px"};
  height: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? "calc(100vh - 130px) !important"
      : "calc(100vh - 210px) !important"};
  overflow: auto;
`;
const ScheduledDiv2 = styled<any>("div")`
  width: ${({ screen, mode }: any) =>
    ["lectureDetailTab"].includes(mode)
      ? "100%"
      : ["xs", "sm", "md"].includes(screen)
      ? "70%"
      : "70%"};
  height: ${({ screen, mode }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? ["mybatchSyllabus"].includes(mode)
        ? "calc(100% - 110px)"
        : "calc(100% - 160px)"
      : ""};
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "" : ""};
`;
const LectureStyledContainer = styled<any>("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "" : "1px solid #AFAFAF"};
`;
const LectureStyledSpan1 = styled<any>("div")`
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : "16px"};
  color: #333333 !important;
  font-weight: 700;
  padding: 20px 8px 20px 16px;
`;
interface MyBatchTestSyllabusListingIC {
  testSyllabusDetail: testSyllabusDetailIF;
}

const MyBatchTestSyllabusListing = ({
  testSyllabusDetail,
}: MyBatchTestSyllabusListingIC) => {
  console.log("testSyllabusDetailtestSyllabusDetail", testSyllabusDetail);
  const { screen }: any = useWindowSize();
  const [selectedChapter, setselectedChapter] = useState<any>(
    (testSyllabusDetail && testSyllabusDetail.tableOfContent[0]) || null
  );
  useEffect(() => {
    setselectedChapter(
      (testSyllabusDetail && testSyllabusDetail.tableOfContent[0]) || null
    );
  }, [testSyllabusDetail]);
  const returnChildren = () => {
    if (testSyllabusDetail && testSyllabusDetail.tableOfContent.length) {
      return testSyllabusDetail.tableOfContent
        ? testSyllabusDetail.tableOfContent &&
            testSyllabusDetail.tableOfContent.map((ele: any) => ({
              ...ele,
              name: "Chapter",
              isComplete: returnIsComplete(
                ele.children,
                testSyllabusDetail.nodesMarked
              ),
            }))
        : [];
    }
    return [];
  };
  const returnIsComplete = (contents: any, nodesMArked: any) => {
    let retValue = 0;
    if (contents != null) {
      const allKeysFromContent = getAllNodes(contents);
      const keysFiltered = allKeysFromContent
        .filter((el: any) => el.children == null)
        .map((i: any) => i.key);
      const nodeIdsMarkedArray =
        nodesMArked && nodesMArked != null ? nodesMArked.split(",") : [];
      const checkIdspresent = nodeIdsMarkedArray.filter((item: any) =>
        keysFiltered.includes(item)
      );

      if (keysFiltered.length == checkIdspresent.length) {
        retValue = 3;
      } else if (
        checkIdspresent.length > 0 &&
        checkIdspresent.length < keysFiltered.length
      ) {
        retValue = 2;
      } else {
        retValue = 1;
      }
    }

    return retValue;
  };
  const onSelectHandler = (item: any) => {
    setselectedChapter(item);
  };
  const returnSelectedAllNodes = (arr: any) => {
    return arr.filter((ele: any) => ele.key === selectedChapter?.key);
  };
  const SyllabusTabHeader = () => {
    return (
      <HeaderTabDiv screen={screen}>
        <StyledSpan2 screen={screen}>Topic List</StyledSpan2>
      </HeaderTabDiv>
    );
  };
  const newListingCount = returnChildren();
  const totalCount = newListingCount.length;
  const completeCount = newListingCount.filter((el: any) => el.isComplete == 3);
  const completeCountlength =
    completeCount && Array.isArray(completeCount) && completeCount.length
      ? completeCount.length
      : 0;
  return (
    <MainDiv screen={screen}>
      <ScheduledDiv1 screen={screen} mode={""}>
        <LectureStyledContainer screen={screen}>
          <LectureStyledSpan1 screen={screen}>
            {testSyllabusDetail?.subject}
          </LectureStyledSpan1>
          {["xs", "sm", "md"].includes(screen) ? null : (
            <LectureStyledSpan1 screen={screen}>
              {completeCountlength}/{totalCount}
            </LectureStyledSpan1>
          )}
        </LectureStyledContainer>
        <ChapterListingComponent
          data={returnChildren()}
          selectedChapter={selectedChapter}
          onSelectHandler={onSelectHandler}
        ></ChapterListingComponent>
      </ScheduledDiv1>
      <ScheduledDiv2 screen={screen} mode={""}>
        <PlannedLectureViewCard
          allCourseNodes={
            testSyllabusDetail && testSyllabusDetail?.tableOfContent
              ? returnSelectedAllNodes(testSyllabusDetail?.tableOfContent)
              : null
          }
          mode="mybatchTestSyllabus"
          header={<SyllabusTabHeader />}
          checkedTopicCovered={
            testSyllabusDetail && testSyllabusDetail.nodesMarked != null
              ? testSyllabusDetail.nodesMarked.split(",")
              : []
          }
        ></PlannedLectureViewCard>
      </ScheduledDiv2>
    </MainDiv>
  );
};
export default MyBatchTestSyllabusListing;
